import { common } from '@neo-one/client-common';
export const Hash256 = {
    NEO: common.NEO_ASSET_HASH,
    GAS: common.GAS_ASSET_HASH,
};

//# sourceMappingURL=Hash256.js.map
